<template>
	<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/huodonglist' }">活动列表</el-breadcrumb-item>
			<el-breadcrumb-item>添加活动</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="80px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="文章权重">
					<el-input v-model="formData.weights" style="width: 70px;" type="number"></el-input>
					<el-tag style="margin-left: 20px;" type="danger">权重越高，排序越靠前</el-tag><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="文章封面">
					<!-- <el-input v-model="formData.picUrl"></el-input> -->
					<!-- v-model="formLabelAlign.name" -->
					<!-- <img :src="$imgTitle+formData.picUrl" /> -->
					<el-upload class="upload-demo" list-type="picture" :action="uploadUrl" :limit="1" :file-list="fileList" :on-remove="onRemove"
					 :on-success="onSuccess">
						<el-button size="small" type="primary">点击上传图片</el-button><!-- <el-tag style="margin-left: 20px;" type="danger">点击上传文章封面图</el-tag> -->
					</el-upload>
				</el-form-item>
				<el-form-item label="文章标题">
					<el-input v-model="formData.title"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="文章简介">
					<el-input v-model="formData.introduction"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="分类">
					<el-input disabled placeholder="活动"></el-input><!-- v-model="formLabelAlign.type" -->
				</el-form-item>
				
				<el-form-item label="详情">
					<el-upload class="avatar-uploader" :action="uploadUrl" type="drag" :show-file-list="false" :on-success="uploadSuccess">
					</el-upload>
					<quill-editor v-model="quillData" :options="editorOption" ref="myref"></quill-editor>
				</el-form-item>
			</el-form>
			
			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>


		<div :visible.sync="videoUploadTag">
			<el-dialog width="50%" id="video_upload" style="margin-top: 1px" title="填写视频连接" :visible.sync="videoUploadTag"
			 append-to-body>
				
				<el-form label-width="80px" :model="formData">
					<el-form-item label="视频连接">
						<el-input v-model="videoLink"></el-input><!-- v-model="formLabelAlign.type" -->
					</el-form-item>
				</el-form>
				<el-button type="primary"  style="margin: 20px 0px 0px 80px " @click="addVideoLink()">添加
				</el-button>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		['blockquote', 'code-block'],

		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // superscript/subscript
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction

		[{
			'size': ['12px', '14px', false, '18px', '22px', '26px', '30px', '36px', '42px']//['small', false, 'large', 'huge']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],

		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image', 'video'],
		['clean'] // remove formatting button
	]
	import {
		quillRedefine
	} from 'vue-quill-editor-upload' //引入图片上传
	
	
	import ImageResize from 'quill-image-resize-module' 
	Quill.register('modules/imageResize', ImageResize) 
	
	export default {
		components: {

		},
		data() {
			var self2 = this;
			return {
				//显示插入视频链接弹框的标识
				videoUploadTag: false,
				//弹框插入的视频链接记录
				videoLink: "",
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				/* fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}], */
				fileList: [],
				fileList2: [],
				id: '',
				detailData: {},
				quillData: '',
				formData: {
					picUrl: '',
					title: '',
					quillData: '',
					introduction: '',
					weights: ''
				},

				editorOption: {
					theme: 'snow', // or 'bubble'
					modules: {
						imageResize: { //放大缩小
							displaySize: true
						},
						toolbar: {
							container: toolbarOptions, // 工具栏
							handlers: {
								'image': function(value) {
									if (value) {
										// 触发input框选择图片文件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								},
								'video': function(value) {
									self2.videoUploadTag = true;
								}
							}
						}
					}
				},

			}
		},
		created() {
			var that = this
			setTimeout(function() {
				console.log(that.$refs.myref.quill)
			}, 100)

			/*console.log('获取到的id=' + this.$route.query.id)
			this.id = this.$route.query.id;
			 this.getDetailData(); */
			/* this.editorOption = quillRedefine( //修改富文本编辑器图片上传路径
				{
					// 图片上传的设置
					uploadConfig: {
						action: this.uploadUrl, // 必填参数 图片上传地址
						res: (respnse) => {
							console.log('进入了respnse=' + respnse)
							return respnse.data.src; //return图片url
						},
						name: 'img' // 图片上传参数名
					}
				}) */


			var data = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"id": 12,
						"createTime": 1588217780000,
						"updateTime": 1588217788000,
						"title": "新品上市 | 慕茹姬氨基酸洗面奶，深彻清洁面部肌肤，敏感肌救星 ",
						"introduction": "化妆不洗脸，变成痘痘脸~\r\n洁面的重要性想必大家都知道\r\n就算平时很少化妆\r\n但是每日接触的粉尘雾霾等\r\n如果清洁不彻底的话\r\n也是造成皮肤暗沉、黑头的主要原因\r\n所以认真洁面很重要！！",
						"content": "<p>\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130103666296.jpg\" title=\"activityNewInfo/202006161120496123765.jpg\" alt=\"微信图片_20200612143714.jpg\"/>\r\n</p>\r\n<p style=\"text-align: center;\">\r\n    <span style=\"font-size: 16px;\"><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255);\"><span style=\"font-family: 宋体;\">化妆不洗脸，变成痘痘脸</span>~</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">洁面的重要性想必大家都知道</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">就算平时很少化妆</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">但是每日接触的粉尘雾霾等</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">如果清洁不彻底的话</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">也是造成皮肤暗沉、黑头的主要原因</span><span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px;\"><br/></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体;\">所以认真洁面很重要！！</span></span>\r\n</p>\r\n<p>\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130110333934.gif\" title=\"activityNewInfo/202006161123014102821.gif\" alt=\"微信图片_20200612143729.gif\"/>\r\n</p>\r\n<p style=\"text-align: center;\">\r\n    <span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-family: 宋体; font-size: 16px;\">如果你是敏感皮肤或是干燥皮肤，那就要更加注意水温啦，水温不能太烫或太冷，感觉温凉最好，不合适的温度会加重皮肤负担。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 宋体; color: rgb(51, 51, 51); letter-spacing: 1px; background: rgb(255, 255, 255); font-size: 16px;\">&nbsp;</span>\r\n</p>\r\n<p style=\"margin-top:0;margin-bottom:0;text-align:center;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-family: 宋体; font-size: 16px;\">这次小编向大家介绍</span>\r\n</p>\r\n<p style=\"margin-top:0;margin-bottom:0;text-align:center;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\"font-size: 16px;\"><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\">适合所有肌肤的</span><strong><span style=\"color: rgb(64, 118, 0); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\">慕茹姬氨基酸洗面奶</span></strong><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\">，</span></span>\r\n</p>\r\n<p style=\"margin-top:0;margin-bottom:0;text-align:center;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\"font-family: Arial; color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 16px;\"><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 16px; font-family: 宋体;\">让肌肤会呼吸哟！</span>~</span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <span style=\";font-family:Arial;color:rgb(51,51,51);letter-spacing:1px;font-size:14px\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130119807630.gif\" title=\"activityNewInfo/202006161124005805065.gif\" alt=\"微信图片_20200612143736.gif\"/></span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong><span style=\"color: rgb(64, 118, 0); letter-spacing: 1px; background: rgb(254, 254, 254); font-family: 宋体;\">慕茹姬氨基酸洗面奶</span></strong><span style=\"font-family: Arial; color: rgb(63, 63, 63); letter-spacing: 1px; font-size: 14px; background: rgb(254, 254, 254);\"><span style=\"font-family:宋体\">，是一款亲肤温和的洗面奶。在高效清洁的同时温和亲肤低刺激，起泡性强。氨基酸本身是弱酸性，切合肌肤的</span>PH<span style=\"font-family:宋体\">值是</span>5.3<span style=\"font-family:宋体\">，</span>PH<span style=\"font-family:宋体\">值与人体肌肤接近。加上氨基酸是构成蛋白质的基本物质，所以温和亲肤，不会对肌肤的酸碱度造成影响。不但适合痘痘肌肤的人使用，敏感肌肤也可以使用。</span></span><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; font-family: 宋体;\">采取天然成分为原料制造而成。氨基酸作为表面活性剂，对肌肤的</span><strong><span style=\"color: rgb(64, 118, 0); letter-spacing: 1px; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; font-family: 宋体;\">刺激性很小，亲肤性也特别好</span></strong><span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; font-family: 宋体;\">，洗净力适中。用后无残留，避免了残留物质对皮肤天然保护层的伤害。</span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; font-family: 宋体;\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130126372846.jpg\" title=\"activityNewInfo/202006161124359447996.jpg\" alt=\"微信图片_20200612143744.jpg\"/></span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <br/>\r\n</p>\r\n<p>\r\n    <strong><span style=\"color: rgb(64, 118, 0); letter-spacing: 1px; font-family: 宋体;\">超温和</span></strong><span style=\";font-family:Calibri;font-size:14px\"><span style=\"font-family:宋体\">，可以平衡我们多年以来由于不懂成分滥用皂基洁面产品而失衡的肌肤。</span>1<span style=\"font-family:宋体\">秒起泡，泡沫绵密顺滑，可深层清洁毛孔，但不会引起皮肤干燥，同时锁住角质层细胞所需水分，不刺激肌肤。</span><br/></span><span style=\"color: rgb(53, 50, 50); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\">瓶身</span><strong><span style=\"color: rgb(64, 118, 0); letter-spacing: 1px; font-family: 宋体;\">自带创新食用级柔软硅胶刷头，</span></strong><span style=\"color: rgb(53, 50, 50); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\">质地相当柔软用完之后可以快速干燥，大大减少细菌的增生，更卫生更安全！</span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255); text-align: center;\">\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130132154341.jpg\" title=\"activityNewInfo/202006161125020127415.jpg\" alt=\"1592191993(1).jpg\"/><span style=\"font-size: 16px;\"><span style=\"letter-spacing: 1px; text-indent: 28px; font-family: 宋体;\">清洁</span><span style=\"font-family: Arial; letter-spacing: 1px; text-indent: 28px;\">·</span><span style=\"letter-spacing: 1px; text-indent: 28px; font-family: 宋体;\">深层洁肌</span></span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255); text-align: center;\">\r\n    <span style=\"font-family: 宋体; letter-spacing: 1px; text-indent: 16px; font-size: 16px;\">温和卸除残留妆容</span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255); text-align: center;\">\r\n    <span style=\"font-family: 宋体; letter-spacing: 1px; text-indent: 8px; font-size: 16px;\">洗净污垢杂质、泡沫丰盈细腻、洗后清爽光滑</span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <span style=\"font-family: 宋体; font-size: 14px; letter-spacing: 1px; text-indent: 8px;\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130138562032.jpg\" title=\"activityNewInfo/202006161125568415164.jpg\" alt=\"微信图片_20200612143802.jpg\"/></span>\r\n</p>\r\n<p style=\"margin-top: 0px; margin-bottom: 0px; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <span style=\"font-family: 宋体; font-size: 14px; letter-spacing: 1px; text-indent: 8px;\"></span>\r\n</p>\r\n<p>\r\n    <strong><span style=\"color: rgb(252, 246, 230); letter-spacing: 3px; background: rgb(221, 237, 235); font-family: 宋体;\">慕茹姬氨基酸洗面奶适合人群</span></strong>\r\n</p>\r\n<p style=\"margin-top:0;margin-right:16px;margin-bottom:0;margin-left:16px;text-align:justify;text-justify:inter-ideograph;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\";font-family:Arial;color:rgb(51,51,51);letter-spacing:1px;font-size:14px\"><span style=\"font-family:宋体\">（</span>1<span style=\"font-family:宋体\">）成分天然，温和，刺激性小。特别适合皮肤清洁，尤其适合母婴儿童皮肤清洁使用。</span></span>\r\n</p>\r\n<p style=\"margin-top:0;margin-right:16px;margin-bottom:0;margin-left:16px;text-align:justify;text-justify:inter-ideograph;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\";font-family:Arial;color:rgb(51,51,51);letter-spacing:1px;font-size:14px\"><span style=\"font-family:宋体\">（</span>2<span style=\"font-family:宋体\">）清洁力适中，不会产生过度去脂。特别适合敏感肌肤、薄皮肤、红血丝肌肤、健康肌肤长期使用。</span></span>\r\n</p>\r\n<p style=\"margin-top:0;margin-right:16px;margin-bottom:0;margin-left:16px;text-align:justify;text-justify:inter-ideograph;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\";font-family:Arial;color:rgb(51,51,51);letter-spacing:1px;font-size:14px\"><span style=\"font-family:宋体\">（</span>3<span style=\"font-family:宋体\">）呈弱酸性。不降低皮肤抵抗力，弱酸性环境可以抑制皮肤表面细菌的生长，长期使用弱酸性洗面奶可预防痘痘毛囊炎的产生，所以，特别适合青春期痘痘肌肤使用。</span></span>\r\n</p>\r\n<p style=\"margin-top:0;margin-right:16px;margin-bottom:0;margin-left:16px;text-align:justify;text-justify:inter-ideograph;line-height:32px;background:rgb(255,255,255)\">\r\n    <span style=\"color: rgb(51, 51, 51); letter-spacing: 1px; font-size: 14px; font-family: 宋体;\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161130144317901.jpg\" title=\"activityNewInfo/202006161127438432308.jpg\" alt=\"1592278049(1).jpg\"/></span>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong style=\"text-indent: 28px;\"><span style=\"font-family: 宋体;\">抢购开启</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong style=\"text-indent: 28px;\"><span style=\"font-family: 宋体;color: rgb(255, 255, 255);font-size: 18px;background: rgb(0, 176, 80)\">&nbsp;九航云选商城&nbsp;</span></strong><strong style=\"text-indent: 28px;\"><span style=\"font-family: 宋体; color: rgb(118, 146, 60);\">购买通道已开启</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong style=\"text-align: center;\"><span style=\"font-family: 宋体; color: rgb(255, 0, 0); letter-spacing: 2px;\">限时抢购 数量有限 抢到赚到</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong style=\"text-align: center;\"><span style=\"font-family: 宋体;color: rgb(118, 146, 60);letter-spacing: 2px;font-size: 15px\">新品特惠</span></strong><strong style=\"text-align: center;\"><span style=\"font-family: &#39;Times New Roman&#39;;color: rgb(118, 146, 60);letter-spacing: 2px;font-size: 15px\">↔</span></strong><strong style=\"text-align: center;\"><span style=\"font-family: 宋体;color: rgb(118, 146, 60);letter-spacing: 2px;font-size: 15px\">129元/支</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong><span style=\"font-family: 宋体;color: rgb(255, 0, 0);letter-spacing: 2px;font-size: 30px\">129元/支！</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong><span style=\"font-family: 宋体; color: rgb(255, 0, 0);\">也太划算了吧！</span></strong>\r\n</p>\r\n<p style=\"margin: 0px 16px; text-align: center; line-height: 32px; background: rgb(255, 255, 255);\">\r\n    <strong style=\"text-indent: 28px;\"><span style=\"font-family: 宋体; color: rgb(255, 0, 0);\">集美们，囤它！买它！</span></strong>\r\n</p>",
						"weights": 12,
						"coverPicture": "activityNewInfo/202006151134177453887.gif"
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"date": "Sun, 28 Jun 2020 03:12:34 GMT",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/news/activity/detail",
					"method": "get",
					"params": {
						"id": "12"
					},
					"headers": {
						"Accept": "application/json, text/plain, */*"
					},
					"baseURL": "http://120.24.239.84:8701",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}

		},
		methods: {
			 addVideoLink() {
			        if (this.videoLink.length == 0) {
			         return this.$message.error('请输入视频链接！');
			        }
			        //当编辑器中没有输入文本时，这里获取到的 range 为 null
			        var range = this.$refs.myref.quill.getSelection();
			        //视频插入在富文本中的位置
			        var index = 0;
			        if (range == null) {
			          index = 0;
			        } else {
			          index = range.index;
			        }
			        //隐藏弹框
			        this.videoUploadTag = false;
			        //将视频链接插入到当前的富文本当中
			        this.$refs.myref.quill.insertEmbed(index, 'video', this.videoLink);
			      },
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = [];
			},
			onSuccess(res) {
				console.log('res=' + JSON.stringify(res))
				this.fileList2.push(res)
			},
			handleSuccess(res) {

				// 获取富文本组件实例
				let quill = this.$refs.QuillEditor.quill
				// 如果上传成功
				if (res) {
					// 获取光标所在位置
					let length = quill.getSelection().index;
					// 插入图片，res为服务器返回的图片链接地址
					quill.insertEmbed(length, 'image', res)
					// 调整光标到最后
					quill.setSelection(length + 1)
				} else {
					// 提示信息，需引入Message
					Message.error('图片插入失败')
				}
			},
			uploadSuccess(res, file) { // res为图片服务器返回的数据
				var that = this
				console.log('uploadSuccess res=' + JSON.stringify(res))
				setTimeout(function() {
					console.log("194=" + that.$refs.myref)
					let quill = that.$refs.myref.quill;

					if (res) {
						let length = quill.getSelection().index; // 获取光标所在位置
						quill.insertEmbed(length, 'image', that.$imgTitle + res); // 插入图片  res.info为服务器返回的图片地址
						quill.setSelection(length + 1); // 调整光标到最后
					} else {
						that.$message.error('图片插入失败')
					}
					that.quillUpdateImg = false; // loading动画消失
				}, 0)

			},
			async getDetailData() {
				const res = await this.$http.get('/v1/official/news/activity/detail', {
					params: {
						id: this.id
					}
				})
				console.log(JSON.stringify(res))
				if (res.data.code == 0) {
					this.detailData = res.data.data;
					this.formData.picUrl = this.detailData.coverPicture;
					this.formData.title = this.detailData.title;
					this.formData.introduction = this.detailData.introduction
					this.formData.quillData = this.detailData.content;
					var obj = {};
					obj.name = '原来文章封面图'
					obj.url = this.$imgTitle + this.detailData.coverPicture;
					this.fileList.push(obj)
				}
			},
			async submit() {
				//console.log(this.quillData)
				var obj = {};
				obj['title'] = this.formData.title
				obj['introduction'] = this.formData.introduction
				obj['content'] = this.quillData
				obj['weights'] = +this.formData.weights
				obj['coverPicture'] = this.fileList2.join(',')
				obj['type'] = 1 //类型活动 1 资讯 2

				console.log(JSON.stringify(obj))
				if (obj.title == '' || obj.introduction == '') {
					return this.$message.error('请添加文章的标题或简介')
				}
				if (obj.content == "") {
					return this.$message.error('请添加文章的详情')
				}
				if (obj.coverPicture == "") {
					return this.$message.error('请添加文章的封面图')
				}
				const res = await this.$http.post('/v1/official/manag/news/activity/add', {
					request: obj
				})
				console.log('res=' + JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('添加成功')
					this.$router.push({
						path: '/huodonglist'
					})
				} else {
					this.$message.error(res.data.message)
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.el-card {
		/* width: 1000px; */
	}

	.submitBtn {
		margin: 0 auto;
		margin-top: 90px;
		margin-left: 80px;
	}
</style>
